/**
 * Default values used throughout the application.
 * Fallback values when user preferences or context are not available.
 */

/** Prefix for message IDs that should not be rendered in UI */
export const DO_NOT_RENDER_ID_PREFIX = "do-not-render-" as const;
